module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAD7AQMAAAB65de2AAAAA1BMVEUAAACnej3aAAAADUlEQVQY02MYBSMQAAAB9gABXtwJ0QAAAABJRU5ErkJggg=="